export default "__VITE_ASSET__B5g6si8m__"